import React from "react";
import { Link } from "react-router-dom";
import { cutText } from "../../../Utils/functions";

const BlogCard = ({ blog }) => {

  return (
    <Link
      to={`/Blogs/${blog && blog.slug}`}
      className="col-md-4 col-lg-3 blog-card"
    >
      <div
        className="new-box-shadow"
        style={{
          borderRadius: "10px",
          margin: "10px 0",
          overflow: "hidden",
          maxHeight: "400px",
        }}
      >
        <div style={{ padding: "5px" }}>
          <img
            src={blog?.image[0]?.url || blog?.image?.url}
            alt={blog?.image?.alt || blog.title}
            style={{
              width: "100%",
              height: "180px",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          />
        </div>
        <div
          style={{
            padding: "5px",
          }}
        >
          <div style={{}}>
            <h5
              className=" border-bottom  pb-2"
              style={{
                color: "#404040",
                fontSize: "15px",
                fontWeight: "500",
                minHeight: "54px",
                textAlign: "center",
              }}
            >
              {blog.title}
            </h5>
          </div>
          <div
            className="pt-2"
            style={{
              // padding: "15px",
              textAlign: "center",
              color: "#404040",
              fontSize: "12px",
              fontWeight: "400",
            }}
            dangerouslySetInnerHTML={{
              __html: cutText(blog && blog.description, 90),
            }}
          />
          <div className="d-flex justify-content-between align-items-center mt-3 mb-1 px-1">
            <h6
              style={{
                fontSize: "10px",
                color: "#B1B1B1",
                fontWeight: "400",
              }}
            >
              <img
                src={require("../../../Assets/images/write.png")}
                style={{
                  width: "10px",
                  height: "10px",
                  marginLeft: "5px",
                }}
                alt="همه ملاقات"
              />
              {blog?.auther?.fullname}
            </h6>
            <h6
              style={{
                fontSize: "10px",
                color: "#B1B1B1",
                fontWeight: "400",
              }}
            >
              <img
                src={require("../../../Assets/images/cat.png")}
                style={{
                  width: "10px",
                  height: "10px",
                  marginLeft: "5px",
                }}
                alt={blog && blog.blog_category && blog.blog_category.name}
              />
              {blog && blog.blog_category && blog.blog_category.name}
            </h6>
          </div>
          <div className="d-flex justify-content-center align-items-center ">
            <Link
              to={`/Blogs/${blog && blog.slug}`}
              style={{
                borderRadius: "10px",
                width: "100%",
              }}
              className="btn btn-blue py-1 mt-1 "
            >
              ادامه مطلب
            </Link>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
